import { render, staticRenderFns } from "./listTabC.vue?vue&type=template&id=416195be&scoped=true"
import script from "./listTabC.vue?vue&type=script&lang=js"
export * from "./listTabC.vue?vue&type=script&lang=js"
import style0 from "./listTabC.vue?vue&type=style&index=0&id=416195be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416195be",
  null
  
)

export default component.exports